// extracted by mini-css-extract-plugin
module.exports = {"componentsMapCard":"styles_componentsMapCard__24i8Q","merchantName":"styles_merchantName__3-ez8"};